import { FC } from 'react';
import { motion } from 'framer-motion';
import { HeroContent } from '../services/contentService';

interface HeroProps {
  content?: HeroContent;
}

const Hero: FC<HeroProps> = ({ content }) => {
  // Default content if CMS data is not available
  const defaultContent: HeroContent = {
    title: "Twoja Przestrzeń, Nasze Doświadczenie",
    subtitle: "Tworzymy ogrody zimowe i zabudowy tarasów, które przekształcą Twój dom w wyjątkowe miejsce"
  };

  const heroContent = content || defaultContent;

  return (
    <div 
      className="relative bg-gradient-to-r from-blue-900 to-blue-700 text-white pt-24 min-h-[70vh] flex items-center"
      lang="pl"
    >
      {/* Content */}
      <div className="container mx-auto py-16 px-4 md:px-8">
        <div className="max-w-3xl">
          <motion.h1 
            className="text-3xl md:text-5xl font-bold mb-4"
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7 }}
          >
            {heroContent.title}
          </motion.h1>
          <motion.p 
            className="text-lg md:text-xl mb-6"
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.4 }}
          >
            {heroContent.subtitle}
          </motion.p>
          <motion.a 
            href="#contact"
            className="bg-white text-blue-900 font-bold py-3 px-8 rounded-md hover:bg-blue-100 transition duration-300 inline-block"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.6 }}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            aria-label="Skontaktuj się z nami"
          >
            Skontaktuj się z nami
          </motion.a>
        </div>
      </div>
    </div>
  );
};

export default Hero;
